import React from "react"
import { BlogBannerListItem } from "../BannerListItem/BlogBannerListItem"
import { BlogPostEdge, BlogPosts } from "./blog-banner-list-types"
import "./blog-banner-list.module.scss"

interface BlogBannerListProps {
  relatedArticles?: BlogPostEdge[]
  posts?: BlogPosts
}

export const BlogBannerList = ({
  relatedArticles,
  posts,
}: BlogBannerListProps) => {
  const getRelatedArticles = (relatedArticles: BlogPostEdge[]) => {
    if (relatedArticles.length > 0) {
      return relatedArticles.map(({ node }: any, index) => {
        if (index >= 2) return null

        const { id, elements } = node

        const { featured_text, heading, published_date, slug } = elements

        return (
          <BlogBannerListItem
            key={id}
            heading={heading?.value}
            slug={slug?.value}
            description={featured_text?.value}
            date={published_date?.value}
            hasButton
          />
        )
      })
    }
  }

  const getBlogArticles = (posts: BlogPosts) => {
    if (posts?.edges?.length === 0) return null
    return posts?.edges?.map(({ node }, index) => {
      if (index >= 2) return null
      const { id, elements } = node

      const { featured_text, heading, published_date, slug } = elements

      let dateString = ""
      if (!!published_date) {
        const dateJS = new Date(published_date.value)
        const dayOfTheMonth = dateJS.getDate()
        const month = dateJS.getUTCMonth() + 1
        const numMonth = month.toLocaleString("en-US", {
          minimumIntegerDigits: 2,
          useGrouping: false,
        })
        const fullYear = dateJS.getUTCFullYear()
        dateString = `${numMonth} | ${dayOfTheMonth} | ${fullYear}`
      }

      return (
        <BlogBannerListItem
          key={id}
          heading={heading?.value}
          slug={slug?.value}
          description={featured_text?.value}
          date={dateString}
          hasButton
        />
      )
    })
  }
  return (
    <div className="fr-blog-banner-list  u-flex-center-align">
      {relatedArticles && getRelatedArticles(relatedArticles)}
      {posts && getBlogArticles(posts)}
    </div>
  )
}
